// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"c54eda62","179":"01226b43","416":"c54eda62","517":"c54eda62","892":"c54eda62","957":"c54eda62"}[chunkId] + ".chunk.css";
};